module.exports = "/templates/dashboard.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/dashboard.html
// module id = 445
// module chunks = 0